// 封装所有与用户相关的网络请求
import request from "@/utils/request";
// 下拉框选择员工
export function empSelectEApi(data) {
  return request({
    url: "/sys/emp/selectEmp",
    method: "POST",
    params: data,
  });
}
// 会员消费等级规则设置
export function ruleInsertApi(data) {
  return request({
    url: "/api/Custlvl/rule/insert",
    method: "POST",
    params: data,
  });
}
// 会员消费等级下拉框
export function queryLSelectApi(data) {
  return request({
    url: "/api/Custlvl/querySelect",
    method: "POST",
    params: data,
  });
}
// 会员消费等级下拉框【客户RMF标签权限】
export function queryRmfSelectApi(data) {
  return request({
    url: "/api/user/defined/query",
    method: "POST",
    params: data,
  });
}
// 会员信息--删除
export function custDeleteApi(data) {
  return request({
    url: "/api/cust/delete",
    method: "POST",
    params: data,
  });
}
// 会员信息--删除
export function mycustDeleteApi(data) {
  return request({
    url: "/api/cust/grplist/deleteCustGrp",
    method: "POST",
    params: data,
  });
}
// 会员信息-(修改)查詢
export function queryAllInfoForUpateApi(data) {
  return request({
    url: "/api/cust/queryAllInfoForUpate",
    method: "post",
    params: data,
  });
}
// 会员修改--保存
export function updateApi(data) {
  return request({
    url: "/api/cust/update",
    method: "POST",
    data: data,
  });
}
// 会员信息----批量导入会员
export function importCustGrpApi(data) {
  return request({
    url: "/api/cust/grplist/importCustGrp",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
// 会员信息----会员新增批量
export function insertBatchApi(data) {
  return request({
    url: "/api/cust/insertBatch",
    method: "post",
    data: data,
  });
}
// 会员列表查询
export function selectMainListApi(data) {
  return request({
    url: "/api/cust/selectMainList",
    method: "POST",
    data: data,
  });
}
// 会员卡号变更
export function updateCardNoApi(data) {
  return request({
    url: "/api/cust/updateCardNo",
    method: "POST",
    params: data,
  });
}
// 会员新增
export function insertApi(data) {
  return request({
    url: "/api/cust/insert",
    method: "POST",
    // headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}
// 会员详情查询
export function selectByIdApi(data) {
  return request({
    url: "/api/cust/selectById",
    method: "POST",
    params: data,
  });
}
// 会员转店列表
export function queryServiceChgRequestLisApi(data) {
  return request({
    url: "/api/cust/queryServiceChgRequestList",
    method: "POST",
    params: data,
  });
}
// 会员转店申请
export function updateServiceApi(data) {
  return request({
    url: "/api/cust/updateService",
    method: "POST",
    params: data,
  });
}
//----------------------
// 合并会员卡
export function cardMergeApi(data) {
  return request({
    url: "/api/cust/cardMerge",
    method: "POST",
    params: data,
  });
}
// 合并查询列表
export function cardMergeListApi(data) {
  return request({
    url: "/api/cust/cardMergeList",
    method: "POST",
    params: data,
  });
}
//-----------------------------
// 会员级别调整---申请
export function custLvlRequestApi(data) {
  return request({
    url: "/api/custLvlRequest/insert",
    method: "POST",
    params: data,
  });
}
// 会员级别调整--查询
export function custLvlRequestPageApi(data) {
  return request({
    url: "/api/custLvlRequest/page",
    method: "GET",
    params: data,
  });
}
//-----------------------------------
// 会员卡号规则设置---新增
export function tCardnoruleApi(data) {
  return request({
    url: "/api/tCardnorule/insert",
    method: "POST",
    params: data,
  });
}
// 会员卡号规则设置---查询
export function selectByCpyNOApi(data) {
  return request({
    url: "/api/tCardnorule/selectByCpyNO",
    method: "POST",
    params: data,
  });
}
//-------------------------------
// 劵号规则设置---查询
export function codeQueryApi(data) {
  return request({
    url: "/api/coupons/code/query",
    method: "POST",
    params: data,
  });
}
// 劵号规则设置---修改
export function codeUpdateApi(data) {
  return request({
    url: "/api/coupons/code/update",
    method: "POST",
    params: data,
  });
}
//------------------------------
// 冻结卡级别
export function freezeInvalidApi(data) {
  return request({
    url: "/api/cust/freeze/invalid",
    method: "POST",
    params: data,
  });
}
// 冻结卡级别--列表
export function freezePageApi(data) {
  return request({
    url: "/api/cust/freeze/page",
    method: "POST",
    params: data,
  });
}
// 冻结卡级别--会员创建
export function freezeInsertApi(data) {
  return request({
    url: "api/cust/freeze/insert",
    method: "POST",
    params: data,
  });
}
// 冻结卡级别-- 作废
export function freezeThawApi(data) {
  return request({
    url: "api/cust/freeze/thaw",
    method: "POST",
    params: data,
  });
}
// 冻结卡级别--文件导入冻结
export function importFreezeExcelApi(data) {
  return request({
    url: "/api/cust/freeze/importFreezeExcel",
    method: "POST",
    data: data,
  });
}
// 冻结卡级别 -- 数据导入冻结
export function insertBatchFreezeApi(data) {
  return request({
    url: "api/cust/freeze/insertBatchFreeze",
    method: "POST",
    data: data,
  });
}
//    改衣单
// 改衣单 -- 创建
export function ChangeclotheslistcreateApi(data) {
  return request({
    url: "api/cust/updress/insert",
    method: "POST",
    params: data,
  });
}
// 改衣单 -- 修改
export function modifyGydlistApi(data) {
  return request({
    url: "api/cust/updress/update",
    method: "POST",
    params: data,
  });
}
// 改衣单 -- 删除
export function DeleteGydlistApi(data) {
  return request({
    url: "api/cust/updress/delete",
    method: "post",
    params: data,
  });
}
// 改衣单 -- 导出
export function CustupdressexportApi(data) {
  return request({
    url: "/api/cust/updress/export",
    method: "post",
    params: data,
  });
}
//------会员消费等级设置---
//  添加会员消费规则和等级
export function ruleInsert(orderRange, data) {
  return request({
    url: `/api/Custlvl/rule/insert`,
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
    params: orderRange,
    data: JSON.stringify(data),
  });
}
// 消费规则-等级列表
export function ruleListApi(data) {
  return request({
    url: "/api/Custlvl/rule/list",
    method: "post",
    params: data,
  });
}
//  添加等级
export function addLevelApi(data) {
  return request({
    url: "/api/Custlvl/Custlevelset/insert",
    method: "post",
    params: data,
  });
}
// 删除
export function ruleDeleteApi(data) {
  return request({
    url: "/api/Custlvl/rule/delete",
    method: "post",
    params: data,
  });
}
// 会员积分规则设置接口---查询
export function accountmnglvlSelectList() {
  return request({
    url: "/api/accountmnglvl/selectList",
    method: "POST",
  });
}
//--------------------------------------
// 会员积分规则设置接口---查询
export function ruleQueryApi(data) {
  return request({
    url: "/api/points/rule/query",
    method: "POST",
    params: data,
  });
}
// 会员积分规则设置---修改
export function ruleUpdateApi(data) {
  return request({
    url: "/api/points/rule/update",
    method: "POST",
    params: data,
  });
}

// 会员积分查询接口
export function selectPageApi(data) {
  return request({
    url: "/api/cust/selectPointCustList",
    method: "GET",
    params: data,
  });
}
// 会员明细流水
export function flowingWaterApi(data) {
  return request({
    url: "/api/cust/pointslog/selectPage",
    method: "GET",
    params: data,
  });
}
//-------------------------
// 会员权益---查询
export function selectByIDApi(data) {
  return request({
    url: "/api/cust/tequity/selectByID",
    method: "POST",
    params: data,
  });
}
// 会员权益---修改
export function upDateByIDApi(data) {
  return request({
    url: "/api/cust/tequity/update",
    method: "POST",
    params: data,
  });
}
// 会员权益---分页
export function tequityPageApi(data) {
  return request({
    url: "/api/cust/tequity/page",
    method: "POST",
    params: data,
  });
}
// 会员权益---删除
export function deleteByIDApi(data) {
  return request({
    url: "/api/cust/tequity/deleteByID",
    method: "post",
    params: data,
  });
}
// 会员权益---启用
export function tequityEffectApi(data) {
  return request({
    url: "/api/cust/tequity/effect",
    method: "post",
    params: data,
  });
}
// 会员权益---新增
export function tequityInsertApi(data) {
  return request({
    url: "/api/cust/tequity/insert",
    method: "post",
    params: data,
  });
}
// 会员权益---禁用
export function tequityDisableApi(data) {
  return request({
    url: "/api/cust/tequity/disable",
    method: "post",
    params: data,
  });
}
// 会员权益---查看
export function tequityqueryApi(data) {
  return request({
    url: "/api/cust/tequity/query",
    method: "post",
    params: data,
  });
}
//-------------------------
// 会员级别调整---查询
export function RequestPageApi(data) {
  return request({
    url: "/api/custLvlRequest/page",
    method: "POST",
    params: data,
  });
}
// 会员级别调整---创建
export function custInsertApi(data) {
  return request({
    url: "/api/custLvlRequest/insert",
    method: "POST",
    params: data,
  });
}
//会员级别调整表格导入接口
export function upExlsx(data) {
  return request({
    url: "/api/custLvlRequest/import",
    method: "POST",
    data: data,
  });
}
//顾问数据获取
export function selectEmpes(data) {
  return request({
    url: "/sys/emp/selectEmp",
    method: "POST",
    params: data,
  });
}
//会员品牌顾问转店导入
export function updataExlsx(data) {
  return request({
    url: "/api/cust/freeze/importCustShopChg",
    method: "POST",
    timeout: 1000 * 600,
    data: data,
  });
}
// 原因定义等级下拉框
export function queryLOptionApi(data) {
  return request({
    url: "/api/reason/selectList",
    method: "POST",
    params: data,
  });
}
// 用户管理 ----------
// 用户管理 ---首页列表
export function SysemppageApi(data) {
  return request({
    url: "/sys/emp/page",
    method: "GET",
    params: data,
  });
}
// 用户管理 --- 创建
export function SysempinsertApi(data) {
  return request({
    url: "/sys/emp/insert",
    method: "POST",
    params: data,
  });
}
// 用户管理 --- 修改
export function SysempupdateApi(data) {
  return request({
    url: "/sys/emp/update",
    method: "POST",
    params: data,
  });
}
// 用户管理 --- 查看
export function SysempqueryApi(data) {
  return request({
    url: "/sys/emp/query",
    method: "POST",
    params: data,
  });
}
// 用户管理 --- 启用
export function SysempenableApi(data) {
  return request({
    url: "/sys/emp/enable",
    method: "POST",
    params: data,
  });
}
// 用户管理 ---禁用
export function SysempdisableApi(data) {
  return request({
    url: "/sys/emp/disable",
    method: "POST",
    params: data,
  });
}
// 用户管理 --- 用户角色定义查询
export function SysempqueryRoleByEmpIDApi(data) {
  return request({
    url: "/sys/emp/queryRoleByEmpID",
    method: "get",
    params: data,
  });
}
// 用户管理 --- 用户角色定义添加
export function SysempRoleinsertApi(data) {
  return request({
    url: "/sys/empRole/insert",
    method: "POST",
    params: data,
  });
}
// 操作角色定义 --- 首页列表
export function SysrolepageApi(data) {
  return request({
    url: "/sys/role/page",
    method: "GET",
    params: data,
  });
}
// 操作角色定义 --- 创建
export function SysroleinsertOperDefindApi(queryinfo, data) {
  return request({
    url: "/sys/role/insertOperDefind",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    params: queryinfo,
    data: data,
  });
}
// 操作角色定义 --- 修改
export function SysroleupdateOperDefindApi(queryinfo, data) {
  return request({
    url: "/sys/role/updateOperDefind",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    params: queryinfo,
    data: data,
  });
}
// 操作角色定义 --- 删除
export function SysroledeleteApi(data) {
  return request({
    url: "/sys/role/delete",
    method: "post",
    params: data,
  });
}
// 操作角色定义 --- 查看
export function SysrolequeryApi(data) {
  return request({
    url: "/sys/role/query",
    method: "get",
    params: data,
  });
}

// 数据角色定义 --- 首页列表
export function SysrolesjpageApi(data) {
  return request({
    url: "/sys/role/page",
    method: "GET",
    params: data,
  });
}
// 数据角色定义 --- 查询区域
export function ShopqueryRegionApi(data) {
  return request({
    url: "/api/shop/queryRegion",
    method: "POST",
    data: data,
  });
}
// 数据角色定义 --- 创建
export function SysroleinsertDataDefindApi(data) {
  return request({
    url: "/sys/role/insertDataDefind",
    method: "POST",
    params: data,
  });
}
// 数据角色定义 --- 修改
export function SysroleupdateDataDefindApi(data) {
  return request({
    url: "/sys/role/updateDataDefind",
    method: "POST",
    params: data,
  });
}
// 数据角色定义 --- 删除
export function SysroledeletesjApi(data) {
  return request({
    url: "/sys/role/delete",
    method: "post",
    params: data,
  });
}
// 数据角色定义 --- 查看
export function SysrolequerysjApi(data) {
  return request({
    url: "/sys/role/query",
    method: "get",
    params: data,
  });
}
// 用户权限查询 -----
// 用户权限查询 ---- 首页
export function SysempRolepageApi(data) {
  return request({
    url: "/sys/empRole/page",
    method: "get",
    params: data,
  });
}
// 用户权限查询 --- 查看
export function SysempRolequeryApi(data) {
  return request({
    url: "sys/empRole/query",
    method: "get",
    params: data,
  });
}
// 用户权限查询  --- 详细功能
export function SysempRolequerylimitsqxApi(data) {
  return request({
    url: "sys/empRole/querylimits",
    method: "get",
    params: data,
  });
}
// -------------
// 系统管理 --- 验证码
export function VerificationCodeApi(data) {
  return request({
    url: "/services/apexrest/member/verficationCode/get",
    method: "get",
    params: data,
  });
}
// 系统管理 --- 重置密码
export function SysempresetPwdApi(data) {
  return request({
    url: "/sys/emp/resetPwd",
    method: "post",
    params: data,
  });
}

// 修改密码
export function SysempupdatePwd(data) {
  return request({
    url: "/sys/emp/updatePwd",
    method: "post",
    params: data,
  });
}
export function selectBussinDefineApi(data) {
  return request({
    url: "/api/bussinDefine/list",
    method: "POST",
    params: data,
  });
}